<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />

    <base-text-field
      v-model="user_name"
      label="이름"
    />

    <!-- <base-text-field
      v-model="user_email"
      label="메일주소"
    /> -->

    <base-text-field
      v-model="user_contact"
      label="연락처"
    />

    <base-textarea
      v-model="user_contents"
      class="mb-6"
      label="문의사항"
    />

    <base-btn
      :color="!theme.isDark ? 'accent' : 'white'"
      :href="mailto"
      outlined
      target="_blank"
    >
      메일 보내기
    </base-btn>
  </div>
</template>

<script>
  export default {
    name: 'BaseContactForm',

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'MAIL US YOUR MESSAGE',
      },
    },

    data: () => ({
      user_name: null,
      user_email: null,
      user_contact: null,
      user_contents: null,
    }),

    computed: {
      mailto: function () {
        return 'mailto:jh.yoon@lithos.kr?subject=[Flag%20Question]&body=' + encodeURI('이름 : ' + this.user_name + '\n연락처 : ' + this.user_contact + '\n문의사항 : ' + this.user_contents)
      },
    },
  }
</script>
